module.exports = __webpack_public_path__ + "img/Features_Screen1.28ce103c.png";